import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import activestatus from "../../assets/images/activeStatus.svg";
import downloadAction from "../../assets/images/download.svg";
import inactivestatus from "../../assets/images/inactivestatus.svg";
import { useDispatch, useSelector } from "react-redux";
import { ChargesListInvoice } from "../../services/ReduxTookit/Slice/CostManagementRedux";
import { commonservices } from "../../services/CommonServices";
import moment from "moment";
import Nodata from "../../component/common-component/Nodata";
import Loader, { LoaderType } from "../../component/common-component/Loader";

const InvoiceDataTable = ({ startDate, endDate }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const InvoiceListData = useSelector(
    (state) =>
      state?.costmanagement?.ChargesListInvoiceData?.data?.data?.data?.dataList1
  );

  const GetInvoiceListFunction = () => {
    setLoading(true);
    const body = {
      startdate: moment(startDate).format("YYYY-MM-DD"),
      enddate: moment(endDate).format("YYYY-MM-DD"),
    };
    dispatch(ChargesListInvoice(body))?.then(() => setLoading(false));
  };

  useEffect(() => {
    GetInvoiceListFunction();
  }, [startDate, endDate]);
  return (
    <Row>
      <Col xl={12}>
        <div className="table-wrapper-main schedular-page-table-height">
          <Table responsive>
            <thead>
              <tr>
                <th className="width175">Invoice Date</th>
                <th className="width150">Invoice No.</th>
                <th className="text-end width175">Invoice Amount(USD)</th>
                {/* <th className="width200 text-center">Currency</th> */}
                <th className="text-center width200">Billing Period</th>
                <th className="text-center width200">Due Date</th>
                <th className="width200">status</th>
                <th className="text-end sticky-actions width200">Action</th>
              </tr>
            </thead>
            <tbody>
              {" "}
              {loading ? (
                <Loader type={LoaderType.TableRow} count={5} nooftd={7} />
              ) : (
                <>
                  {" "}
                  {InvoiceListData?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          {item?.dateofinvoice
                            ? commonservices.convertDateToLocal(
                                item?.dateofinvoice
                              )
                            : ""}
                        </td>
                        <td>{item?.invoiceno}</td>
                        <td className="text-end">
                          ${item?.invoicefinalamount}
                        </td>
                        {/* <td className="text-center">USD</td> */}
                        <td className="text-center">{item?.bellingperiod}</td>
                        <td className="text-center">
                          {item?.invoiceduedate
                            ? commonservices.convertDateToLocal(
                                item?.invoiceduedate
                              )
                            : ""}
                        </td>
                        <td>
                          <div className="mt-1 me-1">
                            {commonservices.getStatus(item?.status_term)}
                          </div>
                        </td>
                        <td
                          className="sticky-actions"
                          onClick={() => {
                            window.open(item?.invoiceurl, "_blank");
                          }}
                        >
                          <div className="all-actions invoice-download-icon">
                            <img src={downloadAction} alt="downloadAction" />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </>
              )}
              {/* <tr>
                <td>11/12/23</td>
                <td>#256584</td>
                <td className="text-end">$5.00</td>
                <td className="text-center">USD</td>
                <td className="text-center">11/12/23 to 12/12/23</td>
                <td className="text-center">12/18/23</td>
                <td>
                  <div className="status-active">
                    <img src={inactivestatus} alt="activestatus" />
                    <span className="fw600 red-color-text">Unpaid</span>
                  </div>
                </td>
                <td className="sticky-actions">
                  <div className="all-actions invoice-download-icon">
                    <img src={downloadAction} alt="downloadAction" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>11/12/23</td>
                <td>#256584</td>
                <td className="text-end">$5.00</td>
                <td className="text-center">USD</td>
                <td className="text-center">11/12/23 to 12/12/23</td>
                <td className="text-center">12/18/23</td>
                <td>
                  <div className="status-active">
                    <img src={inactivestatus} alt="activestatus" />
                    <span className="fw600 red-color-text">Unpaid</span>
                  </div>
                </td>
                <td className="sticky-actions">
                  <div className="all-actions invoice-download-icon">
                    <img src={downloadAction} alt="downloadAction" />
                  </div>
                </td>
              </tr> */}
              {/* {InvoiceListData?.length <= 0 && <Nodata />} */}
            </tbody>
          </Table>
          {InvoiceListData?.length <= 0 && (
            <Table>
              <tbody>
                <tr>
                  <td>
                    <Nodata />
                  </td>
                </tr>
              </tbody>
            </Table>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default InvoiceDataTable;
